<template>
  <vue100vh
    class="body-wrapper"
  >
    <Header />
    <sidebar />
    <alerts-component />
    <section
      class="section"
      :class="{'car-active': viewSelection === constants.viewSelection.Cars}"
    >
      <slot />
    </section>

    <Footer />
  </vue100vh>
</template>

<script>
  import Header from "@/components/Header";
  import Footer from "@/components/Footer";
  import AlertsComponent from "../components/AlertsComponent"
  import Sidebar from "@/components/Sidebar";
  import constants from '../utils/Constants';
  import {mapGetters} from "vuex";
  import vue100vh from 'vue-100vh'

  export default {
    name: "LayoutBasic",
    components: {
      AlertsComponent,
      Header,
      Footer,
      Sidebar,
      vue100vh
    },
    computed: {
      ...mapGetters(['viewSelection'])
    },
    data() {
      return {
        constants: constants,
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";
  @import "@/assets/variables.scss";

  .body-wrapper {
    background-color: $bg-grey;
    display: flex;
    flex-direction: column;

    @include media-breakpoint-down(sm) {
      height: auto;
    }
  }

  header {
    flex-grow: 0;
  }

  .section {
    flex-grow: 1;
    flex-basis: 100%;
  }

  footer {
    flex-grow: 0;
  }

  .car-active {
    max-height: calc(100% - 75px);
  }
</style>